import React from 'react';
import { SponsorSidebar } from '../SponsorAd';
import { SidebarAdStack } from '../AdSystem';
import MemberAdsSidebar from '../MemberAdsSidebar';

export function FeedSidebar({ user, showAds }) {
  if (!showAds) return null;

  return (
    <div className="hidden lg:block">
      <div className="sticky top-24 space-y-6">
        <MemberAdsSidebar limit={4} title="Featured Members" />
        <SponsorSidebar interests={user?.interests || []} page="feed" />
        <SidebarAdStack maxAds={3} />
      </div>
    </div>
  );
}

export default FeedSidebar;
